import axios from 'axios';
import AppConfig from '@/AppConfig';

export class NewsService {
  async getNews(offset: number = 0, languageCode: string = 'en'): Promise<any> {
    return await axios
      .get(`${AppConfig.getAPIBaseUrl()}/news?offset=${offset}&_lang=${languageCode}`)
      .then((response) => {
        return response.data;
      })
      .catch((e) => {
        console.error('Error fetching news from Checkout API: ' + e);
        return {
          has_unread_news: false,
          items: [],
        };
      });
  }
  async markNewsAsRead(): Promise<any> {
    return await axios
      .post(`${AppConfig.getAPIBaseUrl()}/news/mark-as-read`)
      .catch((e) => console.error('Error marking news as read via Checkout API: ' + e));
  }
}
